import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { storeLogger } from 'ngrx-store-logger';
import { environment } from '../../environments/environment';
import { RascunhoAnaliseEffects } from './effects/rascunho-analise.effects';
import * as fromCaracterizacao from './reducers/caracterizacao.reducer';
import * as fromEstablishment from './reducers/establishment.reducer';
import * as fromRascunhoAnalise from './reducers/rascunho-analise.reducer';

export interface State {
  rascunhoAnalise: fromRascunhoAnalise.RascunhoAnaliseState;
  establishment: fromEstablishment.EstablishmentState;
  caracterizacao: fromCaracterizacao.CaracterizacaoState;
}

export const reducers: ActionReducerMap<State> = {
  rascunhoAnalise: fromRascunhoAnalise.reducer,
  establishment: fromEstablishment.reducer,
  caracterizacao: fromCaracterizacao.reducer,
};

export const effects = [RascunhoAnaliseEffects];

export const metaReducersStore: MetaReducer<State>[] = !environment.production
  ? []
  : [];

export function logger(reducer: any): any {
  return storeLogger()(reducer);
}

export const metaReducers = environment.production
  ? metaReducersStore
  : metaReducersStore.concat([logger]);
